import React from 'react';
import Radio from 'relements/build/esm/input/radio';
import File from 'relements/build/esm/input/file';
import Button from 'relements/build/esm/ui/button';
import styled from 'styled-components';
import '../SDKChatIcon/SDKChatIcon.scss';

const StyledButton = styled(Button)`
  width: 120px;
  height: 26px;
  margin-left: 10px;
  color: ${(props) => props.theme.colors.blue.soft};
  border-style: none;
  border-bottom: 2px solid ${(props) => props.theme.colors.blue.soft};
  padding: 0px;
  border-radius: 0px;
  margin-top: 7px;
  &:hover {
    box-shadow: none;
  }
`;

function Notification({
  label = '',
  options = [],
  onChange,
  value,
  disabled = false,
}) {
  const [selectedAudioType, setSelectedAudioType] = React.useState(value);
  const audioPlayer = React.useRef();

  React.useEffect(() => {
    setSelectedAudioType(value);
  }, [value]);

  const onRadioChange = (index) => {
    const newType = {
      type: options[index].type,
      data: {
        audioURL: '',
      },
    };
    setSelectedAudioType(newType);
    onChange(newType);
  };

  // Handle file uplaod event
  const onUrlChange = (url) => {
    const newType = {
      ...selectedAudioType,
      data: {
        audioURL: url,
      },
    };
    setSelectedAudioType(newType);
    onChange(newType);
  };

  return (
    <>
      <div className="chat-icon-label">{label}</div>
      <div className="chat-icon-container">
        {options.map((item, index) => {
          return (
            <div className="chat-icon-notification">
              <div className="chat-icon-radio">
                <Radio.Item
                  label={item.label}
                  className="chat-icon-radio-item"
                  value={item.type === selectedAudioType.type}
                  onChange={() => onRadioChange(index)}
                  disabled={disabled}
                />
              </div>

              {item.type === 'custom' && (
                <>
                  <div style={{ display: 'flex', marginTop: '14px' }}>
                    <File onChange={onUrlChange} type="audio" maxFileSize={2}>
                      {(uploads, renderInput) => {
                        const hide = selectedAudioType.type !== 'custom';
                        return (
                          <div className="chat-icon-upload">
                            <Button
                              className="chat-icon-upload-button"
                              disabled={hide}
                            >
                              Upload Here
                            </Button>
                            {!hide && renderInput()}
                          </div>
                        );
                      }}
                    </File>
                    {selectedAudioType.type === 'custom' &&
                      selectedAudioType.data &&
                      selectedAudioType.data.audioURL && (
                        <>
                          <audio
                            ref={audioPlayer}
                            src={selectedAudioType.data.audioURL}
                          />
                          <div>
                            <StyledButton
                              onClick={() => {
                                audioPlayer.current.play();
                              }}
                            >
                              Click here to listen
                            </StyledButton>
                          </div>
                        </>
                      )}
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
    </>
  );
}

export default Notification;
